import { FormProvider, useForm } from 'react-hook-form/dist/index.ie11';
import { Button, Column, Row } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import PeopleSelectSearch from 'src/components/oneCorp/features/MealCredit/common/formFields/SelectSearch/PeopleSelectSearch';

export interface AssignPersonFormFields {
  id: string;
}

export interface AssignPersonFormProps {
  onFormSubmit: (personToAdd: string) => Promise<void>;
  onCancel: () => void;
}

export function AssignPersonForm({
  onCancel,
  onFormSubmit,
}: AssignPersonFormProps): JSX.Element {
  const useFormProps = useForm<AssignPersonFormFields>({
    mode: 'onChange',
    defaultValues: { id: '' },
  });
  const { handleSubmit, formState } = useFormProps;
  const { isValid, isSubmitting } = formState;

  async function addPerson({ id }: AssignPersonFormFields) {
    await onFormSubmit(id);
    onCancel();
  }

  return (
    <FormProvider {...useFormProps}>
      <form>
        <Row>
          <Column gutter={12} phone={6} tablet={6} desktop={4}>
            <PeopleSelectSearch name="id" />
          </Column>
          <Column gutter={8} phone={3} tablet={3} desktop={2}>
            <Button
              variant="primary"
              block
              buttonSize="small"
              disabled={!isValid || isSubmitting}
              isLoading={isSubmitting}
              onClick={handleSubmit(addPerson)}
            >
              Save
            </Button>
          </Column>
          <Column gutter={8} phone={3} tablet={2} desktop={2}>
            <Button
              disabled={isSubmitting}
              buttonSize="small"
              variant="tertiary"
              block
              type="button"
              onClick={onCancel}
            >
              Cancel
            </Button>
          </Column>
        </Row>
      </form>
    </FormProvider>
  );
}
